import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_OUTLETS, GET_OUTLETS_ERROR, GET_OUTLETS_SUCCESS } from '../../actions.js';

function* getOutlets({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/digital/outlets`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_OUTLETS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_OUTLETS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_OUTLETS_ERROR, payload: error });
  }
}

export function* watchGetOutlets() {
  yield takeEvery(GET_OUTLETS, getOutlets);
}

function* getOutletsSaga() {
  yield all([fork(watchGetOutlets)]);
}

export default getOutletsSaga;
